<style>
li.green:hover {
  text-shadow: 2px 2px 2px #aaa;
  background-color: #def3d4;
}
</style>
<template>
  <div>
    <div class="content-box">
      <div class="os-tabs-w" v-if="current.id">
        <div class="os-tabs-controls os-tabs-complex text-right">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <span aria-expanded="true" class="nav-link active">
                <span class="tab-label">Total Cargo</span>
                <span class="tab-value" style="font-size: 18px;">Q {{ current.valor_total }}</span>
              </span>
            </li>
            <li class="nav-item">
              <span aria-expanded="true" class="nav-link active">
                <span class="tab-label">Total Devuelto</span>
                <span class="tab-value" style="font-size: 18px;">Q {{ current.valor_total_devuelto }}</span>
              </span>
            </li>
            <router-link :to="{
              name: 'cxc-cargos-editar',
              params: { id: current.cargo.id },
            }">
              <li class="green nav-item">
                <span aria-expanded="false" class="nav-link active">
                  <span class="tab-label">Cargo Rel #</span>
                  <span class="tab-value" style="font-size: 18px;">
                    {{ current.cargo.numero }}
                  </span>
                </span>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link class="btn btn-md" href="#" :to="{ name: 'inventario-devoluciones', params: {} }"
                v-if="current.estado != 'A'">
                <i class="os-icon os-icon-arrow-left5" style="color: #24b314"></i>
                <span style="color: #24b314">Regresar</span>
              </router-link>
              <hr>
              <h5 v-if="current.id" class="form-header">
                Devolucion #
                <u>{{ current.numero }}</u>
                &nbsp;
                <div class="badge" :class="{
                  'badge-success': current.estado == 'A',
                  'badge-warning': current.estado == 'B',
                  'badge-danger': current.estado == '9',
                }">
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">{{
                    current.estado_str
                  }}</span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
                <div class="st-meta float-right">
                  <div class="element-actions">
                    <button :disabled="current.estado == 'A'" class="btn btn-outline-dark" @click="imprimir()">
                      <i class="fa fa-print"></i>
                      Imprimir
                    </button>
                    &nbsp;
                    <!-- <div class="btn-group">
                         <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"></i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            class="dropdown-item"
                            :class="{ 'disabled': !(current.estado == 'B')}"
                            @click="abrir"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-unlock"></i>
                            Abrir Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="cerrar"
                            :disabled="!(current.estado == 'A')"
                            href="#"
                          >
                            <i class="fa fa-lock"></i>
                            Cerrar Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="anular"
                            :disabled="!(current.estado != '9')"
                            href="#"
                          >
                            <i class="fa fa-archive"></i>
                            Anular Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="generar_nc"
                            :disabled="!(current.estado != 'A')"
                            href="#"
                          >
                            <i class="fa fa-archive"></i>
                            Generar Nota Credito
                          </button>
                        </div>
                      </div> -->
                  </div>
                </div>
              </h5>
              <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{ current.errors.detail
              }}</small>

              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>NIT de Cliente</label>
                    <input v-model="current.cargo.cliente_nit" class="form-control" :disabled="true" type="text" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Nombre de Cliente</label>
                    <input v-model="current.cargo.cliente_nombre" class="form-control" :disabled="true" type="text" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Fecha</label>
                    <input v-model="current.fecha" class="form-control" :disabled="true" type="text" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Usuario Operación</label>
                    <input :disabled="true" class="form-control" v-model="current.usuario" type="text" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Tienda</label>
                    <input v-model="current.tienda" class="form-control" :disabled="true" type="text" />
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Caja</label>
                    <input v-model="current.caja" class="form-control" :disabled="true" type="text" />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Observación</label>
                    <textarea :disabled="true" v-model="current.observacion" class="form-control" type="text" />
                  </div>
                </div>
              </div>
              <h6 v-if="currentCargo.cargo_d != ''">Resumen de Cargo</h6>
              <div class="table-responsive" v-if="currentCargo.cargo_d != ''">
                <table class="table table-bordered table-striped">
                  <thead class="table-info">
                    <tr>
                      <th class="text-center">SKU</th>
                      <th class="text-center">Descripción</th>
                      <th class="text-center">Unidad de Medida</th>
                      <th class="text-center">Precio</th>
                      <th class="text-center">Cantidad</th>
                      <th class="text-center">Total</th>
                      <th class="text-center">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in currentCargo.cxccargod_set" v-bind:key="detalle.id">
                      <td class="text-left">{{ detalle.producto.sku }}</td>
                      <td class="text-left">
                        {{ detalle.producto.nombre }}
                      </td>
                      <td class="text-center">
                        {{ detalle.unidad_medida.nombre }}
                      </td>
                      <td class="text-right">Q. {{ detalle.precio }}</td>
                      <td class="text-right">{{ detalle.cantidad_um }}</td>
                      <td class="text-right">Q. {{ detalle.total }}</td>
                      <td class="text-center">
                        <button v-if="current.estado == 'A'" class="btn btn-sm btn-outline-dark mr-1" type="button"
                          @click="showModalAdddevolucion(detalle)">
                          <i class="fas fa-money-bill-wave"></i>
                          Devolver Producto
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              &nbsp; &nbsp;
              <h6 v-if="current.devolucioncliented_set != ''">
                Detalle de la Devolución Aplicada
              </h6>
              <div class="table-responsive" v-if="current.devolucioncliented_set != ''">
                <table class="table table-bordered table-striped">
                  <thead class="table-success">
                    <tr>
                      <th class="text-center">SKU</th>
                      <th class="text-center">Descripción</th>
                      <th class="text-center">Posición</th>
                      <th class="text-center">Precio</th>
                      <th class="text-center">Cantidad a Devolver</th>
                      <th class="text-center">Total Cantidad Devuelta</th>
                      <th class="text-center">Pendiente a devolver</th>
                      <th class="text-center">Total</th>
                      <th class="text-center">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.devolucioncliented_set" v-bind:key="detalle.id">
                      <td class="text-center">{{ detalle.producto.sku }}</td>
                      <td class="text-center">
                        {{ detalle.producto.nombre }}
                      </td>
                      <td class="text-center">{{ detalle.posicion }}</td>
                      <td class="text-center">
                        Q. {{ detalle.cargo_d.precio }}
                      </td>
                      <td class="text-center text-success">
                        <strong>{{ detalle.cantidad }}</strong>
                      </td>
                      <td class="text-center">
                        <strong>{{ detalle.cantidad_devuelta }}</strong>
                      </td>
                      <td style="color: #ff0a03" class="text-center">
                        <strong>{{
                          detalle.cantidad_pendiente_devolucion
                        }}</strong>
                      </td>
                      <td class="text-center">Q. {{ detalle.valor_total }}</td>
                      <td class="text-center" style="width: 200px">
                        <button class="btn btn-sm btn-danger mr-1" type="button" v-if="current.estado == 'A'"
                          @click="deleteDetalle(detalle)">
                          <i class="fa fa-trash"></i>
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAdddevolucionDetalle" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Devoluciones</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Producto</label>
                    <input v-model="currentDetalle.producto.nombre" class="form-control" type="text" :disabled="true" />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Cantidad para devolver</label>
                    <input v-model="currentDetalle.cantidad" class="form-control" type="text" />
                    <small v-if="currentDetalle.errors && currentDetalle.errors.cantidad
                      " class="form-text text-danger">{{ currentDetalle.errors.cantidad }}</small>
                  </div>
                </div>
                <!-- <div class="col-sm-12">
                  <div class="form-group">
                    <label>Posicion</label>

                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalle.posicion"
                    >
                      <option
                        v-for="(detalle, key) in posiciones"
                        :value="detalle.id"
                        :key="key"
                      >
                        {{ detalle.posicion_id }}, -- Tienda:
                        {{ detalle.tienda }}
                      </option>
                    </select>
                    <small
                      v-if="
                        currentDetalle.errors && currentDetalle.errors.posicion
                      "
                      class="form-text text-danger"
                      >{{ currentDetalle.errors.posicion }}</small
                    >
                  </div>
                </div> -->
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle" type="button">
              Agregar
            </button>
            <button class="btn btn-secondary" ref="cerrarModalDevoluciones" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import Notifications from "@/notifications/notifications";
import CargosService from "@/services/cxc/CargosService";
import CajaService from "@/services/cxc/CajaService";

export default {
  components: {},
  data() {
    return {
      posiciones: "",
      current: {
        detalle: "",
        id: null,
        devolucioncliented_set: null,
        caja: "",
        cargo_id: "",
        cargo_d: "",
        cargo: "",
        observacion: "",
        cargo_numero: "",
        estado_str: null,
        tienda: "",
        fecha: "",
        estado: "A",
        estado_str: "",
        total: "",
        cliente_nombre: "",
        cliente_nit: "",
        numero: "",
        errors: [],
        cxcabonod_set: [],
        cxcabonocontab_set: [],
        cxcaplicacionabonocargo_set: [],
      },

      productos: [],
      codigo_barra: [],
      detalle: "",
      observacion: "",
      cargo_id: [],
      cargo: [],
      options: [],
      producto_lote: [],
      currentDetalle: {
        cantidad: 0,
        posicion: 0,
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
      currentCargo: {
        cantidad: 0,
        posicion: 0,
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      caja: "cargos/caja",
    }),
  },
  mounted() {
    let self = this;

    this.$store.dispatch("cargos/caja", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
    self.refreshCaja();
    if (!this.$route.params.id) {
      self.cargoCurrent();
    }
  },
  methods: {
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    onSearchPosicion(search, loading) {
      loading(true);
      this.searchPosicion(loading, search, this);
    },
    searchPosicion: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);

        return;
      }
      let that = this;

      PosicionesService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.codigo_barra = res.data;
        loading(false);
      });
    }, 350),
    showModalAdddevolucion(detalle) {
      let self = this;
      self.currentDetalle.producto = detalle.producto;
      self.currentDetalle.cargo_d = detalle.id;
      PosicionesService.fetch({
        page: 1,
        activo: true,
      }).then((res) => {
        self.codigo_barra = res.data.results;
      });
      PosicionesService.fetch({
        tienda: self.current.tienda,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalAdddevolucionDetalle").modal();
    },
    generar_nc() {
      let self = this;
      let current = Object.assign({}, self.current);
      DevolucionesService.generar_nc(self.current.id, current)
        .then((response) => {
          Notifications.alert.success(
            "Devoluciones",
            "Se ha Generado la Nota de Credito."
          );
          self.refreshCurrent();
        })
        .catch((error) => {
          Notifications.alert.error("Devolución", error.response.data.detail);
        });
    },
    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      det.posicion = det.posicion.id;
      DevolucionesService.agregar_detalle(self.current.id, det)
        .then((response) => {
          Notifications.alert.success("Devolución", "Se ha agregado producto.");
          self.refreshCurrent();
          self.refreshDetalleDefault();
          console.log(self.currentDetalle.cantidad);
          self.$refs.cerrarModalDevoluciones.click();
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
        });
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Detalle Devolución",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DevolucionesService.eliminar_detalle(self.current.id, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    refreshCurrent() {
      let self = this;
      DevolucionesService.getById(this.$route.params.id).then((response) => {
        self.current.fecha = response.data.fecha
        self.current.devolucioncliented_set =
          response.data.devolucioncliented_set;
        self.current.id = response.data.id;
        self.current.usuario = response.data.usuario.name;
        self.current.observacion = response.data.observacion;
        self.current.caja = response.data.caja.caja;
        self.current.tienda = response.data.caja.tienda;
        self.current.cargo_id =
          response.data.devolucionclienteecargoe_set[0].cargo_e.id;
        self.current.cargo_numero =
          response.data.devolucionclienteecargoe_set[0].cargo_e.numero;
        self.current.numero = response.data.numero;
        self.current.estado = response.data.estado;
        self.current.estado_str = response.data.estado_str;
        self.current.tienda = response.data.tienda.codigo;
        self.current.cargo =
          response.data.devolucionclienteecargoe_set[0].cargo_e;
        self.current.valor_total_devuelto = response.data.valor_total_devuelto;
        self.current.valor_total =
          response.data.devolucionclienteecargoe_set[0].cargo_e.valor_total;
        self.cargoDetalleCurrent();
      });
    },

    cargoCurrent() {
      let self = this;
      CargosService.getById(this.$route.params.cargo).then((response) => {
        self.current.cargo_id = response.data.id;
        self.current.cargo_numero = response.data.numero;
      });
    },
    cargoDetalleCurrent() {
      let self = this;
      let current = Object.assign({}, self.current);
      CargosService.getById(current.cargo_id).then((response) => {
        self.currentCargo = response.data;
      });
    },

    // guardar(e) {
    //   e.preventDefault();
    //   let self = this;
    //   let current = Object.assign({}, self.current);
    //   CargosService.getById(current.cargo_id).then((response) => {
    //     self.current.cargo_d = response.data.cxccargod_set;
    //   });
    //   DevolucionesService.save(current)
    //     .then((response) => {
    //       if (current.id == null) {
    //         Notifications.alert.success("Devuluciones", "Ir a detalle.", "");
    //         self.$refs.cerrarModalDetalle.click();
    //         self.$router.push({
    //           name: "inventario-devoluciones-editar",
    //           params: { id: response.data.id },
    //         });
    //         self.refreshCurrent();
    //       }
    //     })
    //     .catch((error) => {
    //       self.current.errors = error.response.data;
    //       if (error.response.data.devolucion_cliente) {
    //         Notifications.alert.error(
    //           "Error",
    //           error.response.data.devolucion_cliente
    //         );
    //       }
    //     });
    // },

    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          DevolucionesService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DevolucionesService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },

    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          DevolucionesService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    onSearchCliente(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/clientes", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),

    onSearchCargo(search, loading) {
      loading(true);
      this.searchCargo(loading, search, this);
    },
    searchCargo: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      CargosService.fetch({
        page: 1,
        quitar_paginacion: true,

        "filter[search]": search,
      }).then((res) => {
        vm.cargo = res.data;
        loading(false);
      });
    }, 350),

    refreshCaja() {
      let self = this;
      self.$store.dispatch("cargos/caja", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: 0,
        posicion: "",
        errors: [],
        producto: {
          nombre: "",
        },
      };
    },
    imprimir() {
      let id;
      id = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let user = localStorage.getItem("id_usuario");
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/devoluciones/devoluciones.jrxml&usuario=${user}&id=${id}`
      );
    },
  },
};
</script>
